export default "__VITE_ASSET__L5XSN_yd__"